export const strict = false
export const plugins = [(store) => {
	if (process.client && window.location.pathname === '/' && typeof window.bridge?.emitToWindow === 'function') {
		store.subscribe((mutation) => {
			window.bridge.emitToWindow('printWindow', 'syncState', mutation)
		})
	}
}]
